import jQuery from 'jquery';
import _ from 'lodash';

blist.namespace.fetch('blist.util');
blist.namespace.fetch('blist.util.patterns');

// expose Sizzle globally
window.Sizzle = jQuery.find;

// Prototype defs
String.prototype.startsWith = function (str) { //eslint-disable-line no-extend-native
  return this.indexOf(str) == 0;
};

String.prototype.endsWith = function (str) { //eslint-disable-line no-extend-native
  return this.length >= str.length &&
    this.lastIndexOf(str) == (this.length - str.length);
};

// Caution: common/js_utils/index.js also overrides String.prototype.format
// In pages where both the files are included, based on the order of loading
// <string>.format calls this one or the other one
String.prototype.format = function () { //eslint-disable-line no-extend-native
  var txt = this,

    i = arguments.length;
  while (i--) {
    txt = txt.replace(new RegExp('\\{' + i + '\\}', 'gm'), arguments[i]);
  }
  return txt;
};

/* Adapted from http://blog.mastykarz.nl/measuring-the-length-of-a-string-in-pixels-using-javascript/ */
String.prototype.visualSize = function (fontSize) { //eslint-disable-line no-extend-native
  var $ruler = $('#ruler');
  if ($ruler.length < 1) {
    $('body').append('<span class="ruler" id="ruler"></span>');
    $ruler = $('#ruler');
  }
  if (!fontSize) {
    fontSize = '';
  }
  $ruler.css('font-size', fontSize);
  $ruler.text(this + '');
  return {
    width: $ruler.width(),
    height: $ruler.height()
  };
};

String.prototype.visualHeight = function (fontSize) { //eslint-disable-line no-extend-native
  return this.visualSize(fontSize).height;
};

String.prototype.visualLength = function (fontSize) { //eslint-disable-line no-extend-native
  return this.visualSize(fontSize).width;
};

String.prototype.capitalize = function () { //eslint-disable-line no-extend-native
  return this.charAt(0).toUpperCase() + this.substring(1);
};

String.prototype.displayable = function () { //eslint-disable-line no-extend-native
  return $.map(this.replace(/(\S)([A-Z])/g, '$1 $2').replace(/_/g, ' ').split(' '), $.capitalize).join(' ');
};

String.prototype.trim = function () { //eslint-disable-line no-extend-native
  return this.replace(/^\s+/, '').replace(/\s+$/, '');
};

String.prototype.clean = function () { //eslint-disable-line no-extend-native
  // Sometimes strings have &nbsp;, so replace them all with normal spaces
  return this.replace(/\xa0/g, ' ');
};

String.prototype.camelize = function () { //eslint-disable-line no-extend-native
  return _.map(this.split(/[\W_]/), function (item) {
    return item.substring(0, 1).toUpperCase() + item.substring(1);
  }).join('');
};

String.prototype.plainTextToHtml = function () { //eslint-disable-line no-extend-native
  return ('<p>' + this.replace(/\n/g, '</p><p>') + '</p>').replace(/<p><\/p>/g, '<p>&nbsp;</p>');
};

/* from wikibooks: http://en.wikibooks.org/wiki/Algorithm_Implementation/Strings/Levenshtein_distance#JavaScript */
String.prototype.levenshtein = function (other) { //eslint-disable-line no-extend-native
  var l1 = this.length,
    l2 = other.length;
  if (Math.min(l1, l2) === 0) {
    return Math.max(l1, l2);
  }

  var i = 0,
    j = 0,
    d = [];
  for (i = 0; i <= l1; i++) {
    d[i] = [];
    d[i][0] = i;
  }
  for (j = 0; j <= l2; j++) {
    d[0][j] = j;
  }
  for (i = 1; i <= l1; i++) {
    for (j = 1; j <= l2; j++) {
      d[i][j] = Math.min(
        d[i - 1][j] + 1,
        d[i][j - 1] + 1,
        d[i - 1][j - 1] + (this.charAt(i - 1) === other.charAt(j - 1) ? 0 : 1)
      );
    }
  }
  return d[l1][l2];
};

String.prototype.heuristicDistance = function (other) { //eslint-disable-line no-extend-native
  if ($.isBlank(other)) {
    return NaN;
  }

  return this.replace(/^[a-z0-9]/ig, '').toLowerCase().
    levenshtein(other.replace(/^[a-z0-9]/ig, '').toLowerCase());
};

Function.prototype.curry = function () { //eslint-disable-line no-extend-native
  var f = this;
  var appliedArgs = Array.prototype.slice.call(arguments);
  return function () {
    return f.apply(this, appliedArgs.concat(Array.prototype.slice.call(arguments)));
  };
};

String.prototype.linkify = function (extra) { //eslint-disable-line no-extend-native
  if ($.isBlank(this)) {
    return '';
  }
  if ($.isBlank(extra)) {
    extra = '';
  }
  var replacedText, replacePattern1, replacePattern2, replacePattern3;

  //URLs starting with http://, https://, or ftp://
  replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
  replacedText = this.replace(replacePattern1, '<a href="$1" ' + extra + '>$1</a>');

  //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
  replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" ' + extra + '>$2</a>');

  //Change email addresses to mailto:: links.
  replacePattern3 = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;
  replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

  return replacedText;
};

// jQuery defs

(function ($) {

  $.hashHref = function (href) {
    // IE sticks the entire page URL on, so we can't just strip off the hash;
    // instead we need to index into it and take everything after
    return href.slice(href.indexOf('#') + 1);
  };

  $.urlParam = function (url, name, value) {
    var regex = new RegExp('([\\?#&]' + name + '=)([^&#]*)');
    if (value !== undefined && value !== null) {
      return url.replace(regex, '$1' + value);
    }

    var results = regex.exec(url);
    if (results) {
      return results[2] || 0;
    } else {
      return 0;
    }
  };

  $.hasParam = $.urlParam.curry(window.location.href);

  $.toParam = function (hash) {
    return _.map(hash, function (v, k) {
      return escape(k) + '=' + escape(v);
    }).join('&');
  };

  $.escapeQuotes = function (text) {
    if (typeof text !== 'string') {
      return text;
    }
    return $.htmlEscape(text).
      replace(/'/, '&apos;');
  };

  $.unescapeQuotes = function (text) {
    if (typeof text !== 'string') {
      return text;
    }
    return $.htmlUnescape(text).
      replace(/&apos;/g, "'").
      replace(/&#39;/g, "'").
      replace(/&#x27;/g, "'");
  };

  $.htmlEscape = function (text) {
    if (typeof text !== 'string') {
      return text;
    }
    return text.
      replace(/&/g, '&amp;').
      replace(/</g, '&lt;').
      replace(/>/g, '&gt;').
      replace(/"/g, '&quot;');
  };

  $.htmlUnescape = function (text) {
    if (typeof text !== 'string') {
      return text;
    }
    return text.
      replace(/&quot;/g, '"').
      replace(/&gt;/g, '>').
      replace(/&lt;/g, '<').
      replace(/&amp;/g, '&');
  };

  $.unescapeObject = function (obj) {
    if (obj === null || obj === undefined) {
      return obj;
    } else if (typeof obj == 'string') {
      return $.htmlUnescape(obj);
    } else if (typeof obj == 'object') {
      var newObj = obj instanceof Array ? [] : {};
      $.each(obj, function (k, v) {
        newObj[k] = $.unescapeObject(v);
      });
      return newObj;
    } else {
      return obj;
    }
  };

  $.htmlStrip = function (text) {
    // NOTE: This regex is an imperfect filter:
    //
    //  <img src="foo" alt="2 > 1">
    //
    // I would like to replace this with DOMPurify, but its sanitize method will also
    // perform HTML escaping, which is not part of the current contract for this method.
    try {
      return text.replace(/<[^>]*>/g, '');
    } catch (ex) {
      return '';
    }
  };

  $.urlSafe = function (text) {
    var output = text.
      replace(/\s+/g, '-').
      replace(/[^a-zA-Z0-9_\-]/g, '-').
      replace(/\-+/g, '-');
    if (output.length < 1) {
      output = '-';
    }
    return output.slice(0, 50);
  };

  $.capitalize = function (text) {
    text += '';
    return text.charAt(0).toUpperCase() + text.substring(1);
  };

  $.live = function (selector, type, fn) {
    var $obj = $('body');
    $obj.context = document;
    $obj.on(type, selector, fn);
    return $obj;
  };

  // TODO: not integrated with component locale stuffing
  $.t = function (key, data) {
    return $.tNull(key, data) || '(no translation available) - [key: ' + key + ']';
  };
  $.tNull = function (key, data) {
    if (blist.locale == 'nyan') {
      return 'nyan';
    }

    if (!$.subKeyDefined(blist.translations, key)) {
      return null;
    }
    var result = $.deepGetStringField(blist.translations, key);
    if ($.isPlainObject(result) && _.has(data, 'count')) {
      // Someday, we will have real pluralization rules.
      // Our Rails instance doesn't have these yet, though.
      if (data.count == 1) {
        result = result.one;
      } else {
        result = result.other;
      }
      if (!result) {
        return null;
      }
    }
    result = result.replace(/%{[^}]+}/g, function (dataKey) {
      return (data || {})[dataKey.slice(2, -1)] || '';
    });
    return key.endsWith('_html') ? result : $.htmlStrip(result);
  };

  $.rootPath = function () {
    return (blist.locale == blist.defaultLocale) ? '' : ('/' + blist.locale);
  };

  $.path = function (path) {
    return $.rootPath() + (path || '');
  };

  $.localize = function (obj) {
    if (!$.isPlainObject(obj)) {
      return obj;
    }
    return $.subKeyDefined(obj, blist.locale) ? obj[blist.locale] : '';
  };

  /* Do a deep compact on any object.  For any array, run a normal compact on
   * the array; then deep compact all sub-values.  For an object, leave out blank
   * values; and deep compact all the non-blank ones */
  $.deepCompact = function (obj) {
    if (_.isArray(obj)) {
      return _.chain(obj).map(function (o) {
        return $.deepCompact(o);
      }).
        reject(function (o) {
          return $.isBlank(o);
        }).value();
    }

    if (!$.isPlainObject(obj)) {
      return obj;
    }

    var newObj = {};
    _.each(obj, function (v, k) {
      if (!$.isBlank(v)) {
        newObj[k] = $.deepCompact(v);
      }
    });
    return newObj;
  };

  /* Do a deep compare on two objects (if they are objects), or just compare
     directly if they are normal values.  For this case, null == undefined, but
     not 0, empty string or false.  Also, when comparing objects, both objects
     must have all the same keys, even if they are null.  If one object has a key
     with a null value and the other does not have the key, the objects are not
     equal. */
  $.compareValues = function (obj1, obj2) {
    // If directly equal, great
    if (obj1 === obj2) {
      return true;
    }
    // If obj1 is null/undef, then a quick check determines obj2
    if (obj1 === null || obj1 === undefined) {
      if (obj2 === null || obj2 === undefined) {
        return true;
      }
      return false;
    }
    // If obj1 exists, but obj2 doesn't, not equals
    if (obj2 === null || obj2 === undefined) {
      return false;
    }

    // If either is not an object, they aren't equal
    if (!(obj1 instanceof Object) || !(obj2 instanceof Object)) {
      return false;
    }

    // Now we have two real objects to check
    var compareKey = function (o1, o2, k) {
      if (!o1.hasOwnProperty(k) || !o2.hasOwnProperty(k)) {
        return false;
      }
      return $.compareValues(o1[k], o2[k]);
    };
    for (var v1 in obj1) {
      if (!compareKey(obj1, obj2, v1)) {
        return false;
      }
    }
    for (var v2 in obj2) {
      if (!compareKey(obj2, obj1, v2)) {
        return false;
      }
    }
    return true;
  };

  $.syncObjects = function (dest, src) {
    $.extend(dest, src);
    _.each(dest, function (v, k) {
      if (_.isUndefined(src[k])) {
        delete dest[k];
      }
    });
  };

  $.flattenChildren = function (array, key) {
    key = key || 'children';

    var recurse = function (arrayInner) {
      return _.map(arrayInner, function (elem) {
        if (_.isUndefined(elem[key]))
          return elem;
        else
          return [elem, recurse(elem[key])];
      });
    };
    return _.flatten(recurse(array));
  };

  $.unwrapHtml = function (html) {
    return html.replace(/^\s*<[^<>]+>/i, '').replace(/<\/[^<>]+>\s*$/i, '');
  };

  // Get a template DOM fragment, checking first in the JS appended templates,
  // then in the page-injected templates
  $.getTemplate = function (template) {
    var templateSelector = '.' + template;
    var $jsAppendedTemplates = $('#js-appended-templates').children();
    if ($jsAppendedTemplates.is(templateSelector)) {
      return $jsAppendedTemplates.filter(templateSelector);
    }
    return $($('#templates').html()).filter(templateSelector);
  };

  $.renderTemplate = function (template, data, directive, keepText) {
    var $template = $.getTemplate(template);

    if ($template.length < 1) {
      throw 'No template found: ' + template;
    }

    if (_.isUndefined(data)) {
      return keepText ? $template.html() : $template.clone().children();
    } else {
      // IE10 doesn't properly copy the checked state on radio buttons with jQuery clone
      // cloneNode handles it correctly, though
      var $templateCopy = $($template[0].cloneNode(true));

      // pure needs a wrapping element
      $templateCopy.appendTo($('<div/>'));
      // I think this is the cause of the 'ep is null' error in pure; but can't
      // figure out why it would happen...
      if ($.isBlank($templateCopy[0].parentNode)) {
        throw 'templateCopy has no parent!';
      }

      var rendered = $templateCopy.render(data, directive);
      return keepText ? rendered.innerHTML : $(rendered).children();
    }
  };

  $.compileTemplate = function (template, directive) {
    var $templateCopy = $.getTemplate(template).clone();

    if ($templateCopy.length < 1) {
      throw 'No template found: ' + template;
    }

    // pure needs a wrapping element
    $templateCopy.appendTo($('<div/>'));

    var compiledDirective = $templateCopy.compile(directive);

    return function (data) {
      // strip off opening and closing tags of toplevel element
      // to match behavior of $.renderTemplate
      return $.unwrapHtml(compiledDirective(data));
    };
  };

  $.isBlank = function (obj) {
    return _.isUndefined(obj) || _.isNull(obj) || obj === '';
  };

  $.isPresent = function (obj) {
    return !$.isBlank(obj);
  };

  $.arrayify = function (obj) {
    return !_.isArray(obj) ? [obj] : obj;
  };

  $.objectify = function (obj, key) {
    if (!$.isPlainObject(obj)) {
      var newObj = {};
      newObj[key] = obj;
      return newObj;
    }
    return obj;
  };

  $.numericalSanitize = function (str) {
    return (str || '').replace(/[^0-9\.\+\-]/, '');
  };

  $.arrayToObjKeys = function (arr, v) {
    var obj = {};
    _.each($.makeArray(arr), function (k) {
      obj[k] = v;
    });
    return obj;
  };

  // Used to insert items into an object that is acting like a sparse array
  $.addItemsToObject = function (obj, values, index) {
    values = $.makeArray(values);
    var numInserts = values.length;

    // Use a temporary object to hold new indices, so we don't overwrite old
    // as we iterate
    var tmp = {};

    // Move each index up one
    _.each(obj, function (r, i) {
      i = parseInt(i);
      if (i >= index) {
        if (!$.isBlank(r.index)) {
          r.index = i + numInserts;
        }
        tmp[i + numInserts] = r;
        delete obj[i];
      }
    });

    // Merge moved values into original
    $.extend(obj, tmp);

    // Add all the new values
    _.each(values, function (v, i) {
      i = parseInt(i);
      if (!$.isBlank(v.index)) {
        v.index = index + i;
      }
      obj[index + i] = v;
    });
  };

  // Used to remove items from an object that is acting like a sparse array
  $.removeItemsFromObject = function (obj, index, numItems) {
    // Remove specified number of items
    for (var j = 0; j < numItems; j++) {
      delete obj[index + j];
    }

    // Use a temporary object to hold new indices, so we don't overwrite old
    // as we iterate
    var tmp = {};

    // Move each item down one
    _.each(obj, function (r, i) {
      i = parseInt(i);
      if (i > index) {
        if (!$.isBlank(r.index)) {
          r.index = i - numItems;
        }
        tmp[i - numItems] = r;
        delete obj[i];
      }
    });

    // Merge moved values into original
    $.extend(obj, tmp);
  };

  $.keyValueToObject = function (key, value) {
    var temp = {};
    temp[key] = value;
    return temp;
  };

  // goes to a deep location in an object. pass in true
  // as the first arg to force creation of undefined
  // objects on the way to your destination.
  // From https://github.com/clint-tseng/kor.events/blob/master/kor.events.js#L217
  $.deepGet = function ( /* [create], obj, keys* */) {
    var idx = 0;
    var create = false;

    if (arguments[0] === true) {
      idx++;
      create = true;
    }

    var obj = arguments[idx++];

    for (; idx < arguments.length; idx++) {
      var key = arguments[idx];
      if (_.isArray(obj)) {
        var m = key.match(/^\[(\w*)=?(\w*)\]$/);
        if (!$.isBlank(m)) {
          var arrayKey = m[1];
          var arrayVal = m[2];
          var checkVals = !$.isBlank(arrayKey) && !$.isBlank(arrayVal);

          var result;
          var remArgs = $.makeArray(arguments).slice(idx + 1);
          for (var i = 0; i < obj.length; i++) {
            var arrayItem = obj[i];
            if (checkVals && arrayItem[arrayKey] != arrayVal) {
              continue;
            }
            result = $.deepGet.apply($, _.compact([create ? true : null, arrayItem]).
              concat(remArgs));
            if (!create && !$.isBlank(result)) {
              break;
            }
          }
          return result;
        }
      }

      if (_.isString(obj)) {
        try {
          obj = JSON.parse(obj);
        } catch (e) { /* noop */ }
      }

      if (obj[key] == null) // null or undefined
        if (!create)
          return undefined;
        else
          obj[key] = {};

      if (_.isFunction(obj[key])) {
        obj = obj[key].apply(obj);
      } else {
        obj = obj[key];
      }
    }

    return obj;
  };

  $.deepSet = function ( /* obj, value, keys* */) {
    var obj = arguments[0];
    var value = arguments[1];
    for (var i = 2; i < arguments.length - 1; i++) {
      var key = arguments[i];
      if (_.isUndefined(obj[key]))
        obj[key] = {};

      obj = obj[key];
    }
    obj[_.last(arguments)] = value;
  };

  $.deepGetStringField = function (obj, field) {
    return $.deepGet.apply($, [obj].concat(field.split('.')));
  };

  $.deepPluck = function (obj, field) {
    return _.map(obj, function (x) {
      return $.deepGetStringField(x, field);
    });
  };

  $.subKeyDefined = function (obj, keystring) {
    if ($.isBlank(obj) || !_.isString(keystring)) {
      return false;
    }

    var objIter = obj;
    var keys = keystring.split('.');
    while (keys.length > 0) {
      objIter = objIter[keys[0]];
      if ($.isBlank(objIter)) {
        return false;
      }
      keys.shift();
    }
    return true;
  };

  $.isSubKeyEqual = function (obj1, obj2, keystring) {
    if ($.isBlank(obj1) || $.isBlank(obj2) || !_.isString(keystring)) {
      return _.isEqual(obj1, obj2);
    }

    var objIter1 = obj1,
      objIter2 = obj2;
    var keys = keystring.split('.');
    while (keys.length > 0) {
      objIter1 = objIter1[keys[0]];
      objIter2 = objIter2[keys[0]];
      if ($.isBlank(objIter1) || $.isBlank(objIter2)) {
        return _.isEqual(objIter1, objIter2);
      }
      keys.shift();
    }
    return _.isEqual(objIter1, objIter2);
  };

  $.safeId = function (id) {
    return id.replace(/(\.|\:)/g, '\\$1');
  };

  $.arrayToSentence = function (arr, joinWord, separator, alwaysUseSep) {
    return arr.length < 3 ? arr.join((alwaysUseSep ? separator : '') +
      ' ' + joinWord + ' ') :
      arr.slice(0, -1).join(separator + ' ') + separator + ' ' + joinWord +
      ' ' + arr[arr.length - 1];
  };

  $.wordify = function (num) {
    var t = function (str) {
      return $.t('core.numbers.' + str);
    };
    var numWords = {
      '0': t('num_zero'),
      '1': t('num_one'),
      '2': t('num_two'),
      '3': t('three'),
      '4': t('four'),
      '5': t('five'),
      '6': t('six'),
      '7': t('seven'),
      '8': t('eight'),
      '9': t('nine')
    };
    return numWords[num.toString()] || num;
  };

  $.commaify = function (value) {
    value = value + '';
    var pos = value.indexOf('.');
    if (pos == -1) {
      pos = value.length;
    }
    pos -= 3;
    while (pos > 0 && value.charAt(pos - 1) >= '0' && value.charAt(pos - 1) <= '9') {
      value = value.substring(0, pos) + ',' + value.substring(pos);
      pos -= 3;
    }
    return value;
  };

  $.humanify = function (humaneDecimals, fixedDecimals, value) {
    var abs = Math.abs(value);
    return abs >= 1000 ? blist.util.toHumaneNumber(value, humaneDecimals) :
      (abs - Math.floor(abs) > 0 ? value.toFixed(fixedDecimals) : value);
  };

  // it's kind of dumb. if you need anything it doesn't do, just explicitly tell it.
  $.pluralize = function (number, word, pluralized) {
    if (_.isUndefined(pluralized)) {
      if (word.match(/[oiu]$/i))
        pluralized = word + 'es';
      else if (word.match(/y$/i))
        pluralized = word.substring(0, word.length - 1) + 'ies';
      else
        pluralized = word + 's';
    }

    return number + ' ' + ((number === 1) ? word : pluralized);
  };

  $.addAppToken = function (url) {
    return url + ((url.indexOf('?') == -1) ? '?' : '&') +
      'app_token=' + blist.configuration.appToken;
  };

  // force an integer to appear as a double through the json transport
  $.jsonIntToFloat = function (integer) {
    if (integer.toString().indexOf('.') < 0) {
      return parseFloat(integer.toString() + '.000001');
    }
    return integer;
  };

  $.clamp = function (number, bounds) {
    // use ternary for perf
    return number < bounds[0] ? bounds[0] :
      number > bounds[1] ? bounds[1] :
        number;
  };

  // Underscore's _.union uses _.uniq, which uses === rather than _.isEqual.
  $.union = function () {
    return _.reduce(_.flatten(arguments), function (memo, item) {
      if (_.every(memo, function (val) {
        return !_.isEqual(item, val);
      })) {
        memo.push(item);
      }
      return memo;
    }, []);
  };

  $.fn.tagName = function () {
    return this.get(0).tagName.toLowerCase();
  };

  // fast checker for input type
  $.fn.isInputType = function (inputType) {
    return (this.tagName() == 'input') && (this.attr('type') == inputType);
  };

  // Calculate widths/heights without scrollbars to give actual renderable area
  // clientWidth to account for scrollbar, minus padding
  $.fn.renderWidth = function () {
    return this[0].clientWidth - (this.innerWidth() - this.width());
  };

  $.fn.renderHeight = function () {
    return this[0].clientHeight - (this.innerHeight() - this.height());
  };

  $.fn.lockScroll = function (lock) {
    if (lock === true) {
      this.on('mousewheel.lockScroll DOMMouseScroll.lockScroll', function (event) {
        var scrollTo = null;

        if (event.type == 'mousewheel') {
          scrollTo = (event.originalEvent.wheelDelta * -0.5);
        } else if (event.type == 'DOMMouseScroll') {
          scrollTo = 20 * event.originalEvent.detail;
        }

        if (scrollTo) {
          $(this).scrollTop(scrollTo + $(this).scrollTop());
          event.preventDefault();
        }
      });
    } else {
      this.off('mousewheel.lockScroll DOMMouseScroll.lockScroll');
    }
  };

  // hooray, fake green-threading!
  $.batchProcess = function (array, batchSize, eachItem, eachBatch, onComplete) {
    if (!_.isArray(array))
      return;

    array = _.clone(array);

    var thisBatch = array.splice(0, batchSize);
    var batchResult = _.map(thisBatch, eachItem);

    if (_.isFunction(eachBatch))
      eachBatch(batchResult);

    if (array.length === 0) {
      if (_.isFunction(onComplete))
        onComplete();
    } else {
      // 10 ms is long enough a break so that the browser doesn't think we're hung
      setTimeout(function () {
        $.batchProcess(array, batchSize, eachItem, eachBatch, onComplete);
      }, 10);
    }
  };

  $.extract = function (obj, prop) {
    var result = {};
    _.each(obj, function (value, key) {
      result[key] = value[prop];
    });
    return result;
  };

  $.assertThrowOnFail = true;
  $.assert = function (condition, message) {
    if (!condition) {
      console.error('Assertion failed: ' + message);
      if ($.assertThrowOnFail) {
        throw message;
      }
    }
  };

  $.parseParams = function (query) {
    var re = /([^&=]+)=?([^&]*)/g;
    var decode = function (str) {
      return decodeURIComponent(str.replace(/\+/g, ' '));
    };
    var params = {},
      e;
    if (!query) {
      query = window.location.search;
    }
    if (query.substr(0, 1) == '?') {
      query = query.substr(1);
    }

    while (e = re.exec(query)) { //eslint-disable-line no-cond-assign
      var k = decode(e[1]);
      var v = decode(e[2]);
      if (params[k] !== undefined) {
        if (!$.isArray(params[k])) {
          params[k] = [params[k]];
        }
        params[k].push(v);
      } else {
        params[k] = v;
      }
    }
    return params;
  };


  // gives you a faster jquery this on each iter
  jQuery.fn.quickEach = (function () {
    var jq = jQuery([1]);
    return function (c) {
      var i = -1,
        el,
        len = this.length;
      try {
        while (++i < len && (el = jq[0] = this[i]) && c.call(jq, i, el) !== false);
      } catch (e) {
        delete jq[0];
        throw e;
      }
      delete jq[0];
      return this;
    };
  }());

  $.fn.hasChildren = function () {
    var elem = this.get(0);
    return (elem != null) && (elem.firstChild != null);
  };

  $.fn.exists = function () {
    return this.length !== 0;
  };

  // TODO Used only in d3.impl.pie.js - replace with _.constant()
  $.thunk = function (val) {
    return function () {
      return val;
    };
  };

  /**
   * Like jQuery.when, but will never exit early. Instead, failed promises will have the value null.
   *
   * @param {...Promise} - the promises to wait on. Once resolved, the parent promise will resolve.
   * @return {Promise} that resolves when all the given
   */
  $.whenever = function () {
    var args = Array.prototype.slice.call(arguments);
    args = _.map(args, function (promise) {
      var deferred = $.Deferred(); //eslint-disable-line new-cap
      promise.done(function () {
        deferred.resolveWith(null, arguments);
      }).fail(function () {
        deferred.resolve(null);
      });
      return deferred.promise();
    });
    return $.when.apply($, args);
  };

  // @param ary - takes an array of functions.
  // Each function must return a promise.
  //
  // Each function will be executed sequentially, waiting for the
  // previous promise to resolve before firing.
  //
  $.serialPromiser = function (ary) {
    var result = $.Deferred(), //eslint-disable-line new-cap
      promises = _.filter($.makeArray(ary), _.isFunction);

    var promiseIterator = function (promiseFactory, args) {
      promiseFactory.apply(null, args).then(function () {
        if (promises.length > 0) {
          promiseIterator(promises.shift(), arguments);
        } else {
          result.resolveWith(null, arguments);
        }
      }).fail(function () {
        result.reject();
      });
    };
    promiseIterator(promises.shift());

    return result.promise();
  };

  // Wrapper around inlineLogin.verifyUser; simply does nothing
  // if auth fails
  blist.util.doAuthedAction = function (actionText, callback) {
    if (!blist.currentUserId) {
      window.location = $.path('/login');
    } else {
      callback();
    }
  };

  blist.util.railsFlash = function (text, level) {
    var existingFlash = $.cookies.get('js_flash');
    var flashObj = existingFlash ? JSON.parse(existingFlash) : {};
    flashObj[(level || 'notice')] = text;

    $.cookies.set('js_flash', JSON.stringify(flashObj));
  };

  blist.util.patterns.UID = /^\w{4}-\w{4}$/;
  blist.util.patterns.mobileBrowser = /iPhone|iPod|Android/i;
  blist.util.patterns.customUrl = /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
  blist.util.patterns.customHttpMaybeSUrl = /^https?:\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
  blist.util.patterns.core = {
    emailValidator: /^[A-Z0-9._%+-]+@(?:[A-Z0-9-]+\.)+[A-Z]{2,4}$/i,
    urlValidator: /^(mailto\:|(news|(ht|f)tp(s?))\:\/\/)?[a-zA-Z0-9\-\.]+\.([a-zA-Z]{2,}|[0-9]+)(\:\d+)?(\/?\S*)?$/i
  };

  blist.util.isMobile = function () {
    return blist.util.patterns.mobileBrowser.test(navigator.userAgent);
  };
  blist.isMobile = blist.util.isMobile();

  /**
   * @function recursivePluck
   * @description
   * A recursive version of _.pluck.
   *
   * For example:
   * blist.util.recursivePluck({hello: 'world', key: {hello: 'world'}}, 'hello')
   * => ['world', 'world']
   *
   * IMPORTANT: This is not a function for dot-delimited string searches.
   *
   * @param {Array|Object} pluckee - The object to pull searchKey from.
   * @param {Number|String} searchKey - The key within pluckee to pull out.
   * @returns {Array} - All pluckable searchKeys from the pluckee.
   */
  blist.util.recursivePluck = function (pluckee, searchKey) {
    var pluckedArray = [];

    for (var key in pluckee) {
      if (_.isPlainObject(pluckee[key]) || _.isArray(pluckee[key])) {
        var plucked = blist.util.recursivePluck(pluckee[key], searchKey);
        if (_.isArray(plucked)) {
          pluckedArray = pluckedArray.concat(plucked);
        } else {
          pluckedArray.push(plucked);
        }
      }
    }

    if (!_.isUndefined(pluckee[searchKey])) {
      pluckedArray.push(pluckee[searchKey]);
    }

    return pluckedArray;
  };

  // Because NYS dynamically inserts Underscore 1.6.0 into our page, it is capable
  // of overwriting an existing Lodash instance if it has already been loaded.
  // This function checks to see whether or not this occurred and forces it back to
  // using lodash.
  blist.util.enforceLodashFunctions = function () {
    if (window._ !== window.socrataLodash) {
      if (window.console && typeof (window.console.info) === 'function') {
        console.info(
          `Lodash collision detected. Expected version: ${window.socrataLodash.VERSION}. Actual version: ${window._.VERSION}.`
        );
      }
      window.collidedWithLodash = _.noConflict();
      window._ = window.socrataLodash;

      // We are not currently aware of any breakages that
      // this would fix. This is a safety measure in case
      // forcing us back to lodash causes problems for NYS'
      // code.
      //
      // Known NYS cnames:
      // 'health.data.ny.gov',
      // 'nys-staging.demo.socrata.com',
      // 'data.ny.gov',
      // 'nysdoh-staging.demo.socrata.com'
      if (/nys(doh)?-staging|data.ny.gov/.test(window.location.hostname)) {
        var functionsUsedByNYS = [
          'template', 'first', 'keys', 'each', 'extend',
          'debounce', 'pluck', 'reject', 'findWhere'
        ];
        functionsUsedByNYS.forEach(function (func) {
          window._[func] = window.collidedWithLodash[func];
        });
      }
    }
  };

})(jQuery);
